import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const TaxService = {
    getTaxDetailsByTimePeriod: async (startDate, endDate) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/timePeriod?startDate=${startDate}&endDate=${endDate}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getTaxDetailsByYear: async (year) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/annual/${year}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getTaxDetailsByBooking: async (bookingNumber) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/booking/${bookingNumber}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getWalletTaxDetailsByTimePeriod: async (startDate, endDate) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/wallet/timePeriod?startDate=${startDate}&endDate=${endDate}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getWalletTaxDetailsByYear: async (year) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/wallet/annual/${year}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },

    getWalletTaxDetailsByExpertId: async (expertId, startDate, endDate) => {
        const url = `${Helpers.URL()}/api/admin/tax-details/wallet/expert/${expertId}?startDate=${startDate}&endDate=${endDate}`;
        return await commonRequest("get", url, {}, Helpers.token());
    },
    fetchWalletSummaryList: async (data) => {
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        queryParams.append('sortBy', data.filters.sortBy);            
        queryParams.append('sortType', data.filters.sortType || 'desc');
        

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/experts/wallet-summary/list?${queryParams.toString()}`,{}, Helpers.token());   
    },
    fetchWalletSummaryExportList: async (data) => {
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        queryParams.append('sortBy', data.filters.sortBy);            
        queryParams.append('sortType', data.filters.sortType || 'desc');
        

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/experts/wallet-summary/export-list?${queryParams.toString()}`,{}, Helpers.token());   
    },
    
    downloadwalletSummaryInvoice: async (id) => {
        const url = `${Helpers.URL()}/api/v2/admin/experts/wallet-summary/generate-invoice/${id}`;
        return await commonRequest("get", url, {}, Helpers.token(), 'blob');
    },
};
